"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToast = exports.ToastContext = void 0;
Object.defineProperty(exports, "withToast", {
  enumerable: true,
  get: function get() {
    return _drywall.withToast;
  }
});
var _drywall = require("drywall");
var _react = require("react");
var ToastContext = _drywall.ToastContext;
exports.ToastContext = ToastContext;
var useToast = function useToast() {
  return (0, _react.useContext)(_drywall.ToastContext);
};
exports.useToast = useToast;